/**
 * Most popular character encodings
 *
 * Compiled from https://w3techs.com/technologies/overview/character_encoding/all
**/
const encoding = [
  'ANSI_X3.110-1983',
  'Big5',
  'Big5-HKSCS',
  'EUC-JP',
  'EUC-KR',
  'GB18030',
  'GB2312',
  'GBK',
  'ISO-2022-JP',
  'ISO-8859-1',
  'ISO-8859-10',
  'ISO-8859-11',
  'ISO-8859-13',
  'ISO-8859-14',
  'ISO-8859-15',
  'ISO-8859-16',
  'ISO-8859-2',
  'ISO-8859-3',
  'ISO-8859-4',
  'ISO-8859-5',
  'ISO-8859-6',
  'ISO-8859-7',
  'ISO-8859-8',
  'ISO-8859-9',
  'KOI8-R',
  'KOI8-U',
  'KS_C_5601',
  'Shift_JIS',
  'TIS-620',
  'US-ASCII',
  'UTF-16',
  'UTF-7',
  'UTF-8',
  'Windows-1250',
  'Windows-1251',
  'Windows-1252',
  'Windows-1253',
  'Windows-1254',
  'Windows-1255',
  'Windows-1256',
  'Windows-1257',
  'Windows-1258',
  'Windows-31J',
  'Windows-874',
  'Windows-949'
]

export default encoding
